'use client';

import { Suspense } from 'react';
import { MetasView } from '@/components/MetasView';
import { PageSkeleton } from '@/components/PageSkeleton';
import { AppHeaderConfig } from '@/contexts/AppHeaderContext';
import { useChatPage } from '@/hooks/useChatPage';

export default function MetasPage() {
  useChatPage('metas');
  return (
    <div data-onboarding-goals-page>
      <AppHeaderConfig hidePeriodPicker />
      <Suspense fallback={<PageSkeleton />}>
        <MetasView />
      </Suspense>
    </div>
  );
}
